/**
 * SSE ストリームが受け取ったフレーム (またはチャンク) をストアへ適用してよいかの判定。
 *
 * epoch はチャット切替 (teardown) でしか進まないため、それだけでは同一チャット内で
 * ストリームを stop / 再 start した際に、abort 済みストリームの解決済み read() 結果や
 * バッファ済みフレームが適用されてしまう。当該ストリーム自身の abort 状態も併せて見る。
 */
export function isStreamFrameApplicable(input: {
	epochAtStart: number;
	currentEpoch: number;
	aborted: boolean;
}): boolean {
	return input.epochAtStart === input.currentEpoch && !input.aborted;
}
